module.exports = __webpack_public_path__ + "img/nota-codigo-fysson.27a1aad2.png";